module.exports = __webpack_public_path__ + "images/emoji/fish_cake.672ab0ead0de273c59aa.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fish_cake.png
// module id = XBhL
// module chunks = 13